const config = {
    siteUrl: "https://api.dlight.ng/"
    // siteUrl: "https://api4.rush.ng/"
}
module.exports = config;

//"http://localhost:5201/anioma-gas/us-central1",//